import { Box, Typography, Button } from "@mui/material";
import { Add } from "@mui/icons-material";
import { forwardRef, memo } from "react";

const EmptyAdminState = forwardRef(
  ({ isAdmin, onCreateEvent, onCreateSonderEvent, onCreateJahrgang }, ref) => {
    return (
      <Box
        ref={ref}
        sx={{
          mt: 8,
          px: 2,
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        {/* ✅ HEADLINE */}
        <Typography variant="h5" sx={{ mt: 1 }}>
          Lass uns starten 👋
        </Typography>

        {/* ✅ MAIN MESSAGE */}
        <Typography
          variant="body1"
          sx={{
            color: "text.secondary",
            maxWidth: 420,
          }}
        >
          Dieser Sondertag ist noch leer. Beginne, indem du einen ersten Event
          oder einen ersten Sondertag erstellst.
        </Typography>

        {/* ✅ MINI STEPS (guided UX) */}
        <Box sx={{ mt: 1 }}>
          <Typography variant="caption" color="text.secondary">
            1. "Event" / "Sondertag" erstellen
          </Typography>
          <br />
          <Typography variant="caption" color="text.secondary">
            2. "Sondertag" / "Jahrgang" erstellen (min 1)
          </Typography>
          <br />
          <Typography variant="caption" color="text.secondary">
            3. Freigeben
          </Typography>
        </Box>

        {/* ✅ ADMIN ACTION */}

        {isAdmin && onCreateEvent && (
          <Button
            variant="contained"
            size="large"
            startIcon={<Add />}
            onClick={onCreateEvent}
            sx={{
              mt: 2,
              borderRadius: "30px",
              textTransform: "none",
              fontWeight: 600,
              px: 3,
            }}
          >
            Ersten Event erstellen
          </Button>
        )}
        {isAdmin && onCreateSonderEvent && (
          <Button
            variant="contained"
            size="large"
            startIcon={<Add />}
            onClick={onCreateSonderEvent}
            sx={{
              mt: 2,
              borderRadius: "30px",
              textTransform: "none",
              fontWeight: 600,
              px: 3,
            }}
          >
            Ersten Sondertag erstellen
          </Button>
        )}

        {isAdmin && onCreateJahrgang && (
          <Button
            variant="contained"
            size="large"
            startIcon={<Add />}
            onClick={onCreateJahrgang}
            sx={{
              mt: 2,
              borderRadius: "30px",
              textTransform: "none",
              fontWeight: 600,
              px: 3,
            }}
          >
            Ersten Jahrgang erstellen
          </Button>
        )}

        {/* ✅ NON-ADMIN MESSAGE */}
        {!isAdmin && (
          <Typography
            variant="body2"
            sx={{
              mt: 2,
              color: "text.secondary",
            }}
          >
            Warte, bis Events verfügbar sind.
          </Typography>
        )}
      </Box>
    );
  },
);

export default memo(EmptyAdminState);
